import { render, staticRenderFns } from "./NewCustomerProfileSelector.vue?vue&type=template&id=45365d1d&scoped=true&"
import script from "./NewCustomerProfileSelector.vue?vue&type=script&lang=js&"
export * from "./NewCustomerProfileSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45365d1d",
  null
  
)

export default component.exports